import React from 'react';
import styled from 'styled-components';
import { registry } from '../../core/Registry.js';

const Wrapper = styled.div`
  width: ${props => props.width || '100%'};
  max-width: 300px;
  height: ${props => props.height || '400px'};
  perspective: 1000px;
  margin: ${props => props.align === 'center' ? '0 auto' : '0'};
`;

const Inner = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  text-align: center;
  transition: transform 0.8s;
  transform-style: preserve-3d;

  ${Wrapper}:hover & {
    transform: rotateY(180deg);
  }
`;

const Face = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 30px;
  border: 1px solid var(--glass-border);
  box-shadow: 0 10px 30px rgba(0,0,0,0.2);
`;

const Front = styled(Face)`
  background: var(--glass-1);
  color: var(--text-primary);
  backdrop-filter: blur(10px);

  h3 { margin: 15px 0 0 0; font-size: 24px; }
  svg { width: 64px; height: 64px; color: var(--accent); }
`;

const Back = styled(Face)`
  background: linear-gradient(135deg, var(--accent), var(--accent-neon));
  color: #fff;
  transform: rotateY(180deg);

  p { font-size: 16px; line-height: 1.5; margin-bottom: 20px; }
  button {
    background: #fff;
    color: var(--accent);
    border: none;
    padding: 10px 20px;
    border-radius: 8px;
    font-weight: bold;
    cursor: pointer;
  }
`;

const FlipCardWidget = ({ node }) => {
  return (
    <Wrapper align={node.style?.desktop?.align} width={node.style?.desktop?.width} height={node.style?.desktop?.height}>
      <Inner>
        <Front>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"></circle><path d="M12 16v-4M12 8h.01"></path></svg>
          <h3>{node.content?.frontTitle || 'O2 Services'}</h3>
        </Front>
        <Back>
          <p>{node.content?.backText || 'Genießen Sie exklusiven 24/7 Support und VIP-Vorteile in Ihrer O2 App.'}</p>
          <button>{node.content?.btnText || 'Mehr erfahren'}</button>
        </Back>
      </Inner>
    </Wrapper>
  );
};

registry.register('flip_card', {
  label: '3D Flip Card',
  icon: '🔄',
  category: 'advanced',
  defaultContent: {},
  defaultStyle: { desktop: { align: 'center', width: '300px', height: '400px' } },
  render: FlipCardWidget,
  inspectorControls: [
    { tab: 'content', groups: [{ title: 'Inhalte', fields: [{name:'content.frontTitle', label:'Titel Vorne', type:'text'}, {name:'content.backText', label:'Text Hinten', type:'textarea'}, {name:'content.btnText', label:'Button Hinten', type:'text'}] }] },
    { tab: 'style', groups: [{ title: 'Dimensionen', fields: [{name:'style.desktop.width', label:'Breite', type:'text'}, {name:'style.desktop.height', label:'Höhe', type:'text'}, {name:'style.desktop.align', label:'Ausrichtung', type:'select', options:[{label:'Zentriert', value:'center'},{label:'Links', value:'flex-start'}]}] }] }
  ]
});
